// api/customerApi.js
import { apiRequest } from '@/api'

export const customerApi = {
  // 获取客户列表（分页 + 搜索）
  getCustomer(params = {}) {
    const { search = '', page = 1, pageSize = 20 } = params
    const query = new URLSearchParams()
    if (search) query.append('search', search)
    if (page) query.append('page', page)
    if (pageSize) query.append('pageSize', pageSize)
    const url = `/api/customer${query.toString() ? '?' + query.toString() : ''}`
    return apiRequest(url)
  },

  // 新增客户
  addCustomer(name, collapsed = false) {
    return apiRequest('/api/customer/add', {
      method: 'POST',
      body: { name, collapsed }
    })
  },

  // 更新客户
  updateCustomer(id, name, collapsed) {
    return apiRequest('/api/customer/update', {
      method: 'POST',
      body: { id, name, collapsed }
    })
  },

  // 删除客户
  deleteCustomer(id) {
    return apiRequest('/api/customer/delete', {
      method: 'POST',
      body: { id }
    })
  }
}